import React from 'react';
import img from '../assets/images/items/group-ntf-04.png'
import Action from '../components/layouts/Action';
import Header from '../components/header/Header'
import Footer from '../components/footer/Footer'

const Contact = () => {
    return (
        <div className='page-contact'>
            <Header />

            <section className="tf-section contact">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="block-text center">
                                <h1 className="heading-bg" data-aos="fade-in" data-aos-duration="1000"><span>Contacto</span></h1>
                                <h5 className="sub-title mb-10" data-aos="fade-up" data-aos-duration="1000">Escribinos un mensaje!</h5>
                                <h3 className="title mb-28 text-black" data-aos="fade-up" data-aos-duration="1000">Tenes alguna consulta?</h3>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="contact-left text-black">
                                <ul>
                                    <li data-aos="fade-up">
                                        <div className="icon"><i className="fas fa-map-marker-alt"></i></div>
                                        <div className="info">
                                            <h1>Direccion</h1>
                                            <p className="fs-18">Catamarca 72 - San Miguel de Tucuman- Tucuman</p>
                                        </div>
                                    </li>
                                    <li data-aos="fade-up">
                                        <div className="icon"><i className="fas fa-phone-alt"></i></div>
                                        <div className="info">
                                            <h1>Telefono</h1>
                                            <p className="fs-18">+543812100359</p>
                                        </div>
                                    </li>
                                    <li data-aos="fade-up">
                                        <div className="icon"><i className="fas fa-envelope"></i></div>
                                        <div className="info">
                                            <h1>Email</h1>
                                            <p className="fs-18">rodex2022@gmail.com</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <form className="contact__form">

                                <div className="form-group">
                                    <input className="form-control" type="text" placeholder="Your name" required />
                                    <input type="email" className="form-control mr-0" id="exampleInputEmail1" placeholder="Your email" required />
                                </div>
                                <div className="form-group">
                                    <input className="form-control" type="text" placeholder="Your phone" required />
                                    <select className="form-control mr-0" id="exampleFormControlSelect1" >
                                        <option>Subject</option>
                                        <option>Subject 1</option>
                                        <option>Subject 2</option>
                                        <option>Subject 3</option>
                                        <option>Subject 4</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" placeholder="Your message here"></textarea>
                                </div>
                                <button type="submit" className="btn-action style-2"><span>Enviar</span></button>
                            </form>
                        </div>
                    </div>

                </div>

            </section>

            <section className="map">
                <div className="container">
                    <div className="col-12">
                        <p data-aos="fade-up"><iframe title='map' src="https://maps.google.com/maps?q=Catamarca%2072,%20San%20Miguel%20de%20Tucum%C3%A1n&hl=es&z=17&output=embed" width="100%" height="450" allowFullScreen="" loading="lazy" style={{ border: 0 }}></iframe></p>
                    </div>
                </div>
            </section>

            <Action />
            <Footer />
        </div>
    );
}

export default Contact;